import { useState, useEffect } from 'react';

// Detecta tela estreita (celular/tablet) e reage a resize/rotação.
//
// Usado onde os filtros ficam lado a lado no desktop: num celular eles somam
// mais que a largura da tela e os selects ficam espremidos/cortados. No
// compacto, cada filtro passa a ocupar a linha inteira.
//
// ⚠️ ONDE ESTE ARQUIVO NASCEU (2026-09-02): o hook existia DUPLICADO, idêntico,
//    em `manutencao/certificacao/SelecaoPecaCentral.js` e em
//    `operacional/bsv/useEhCompacto.js`. A duplicação era deliberada e estava
//    documentada — importar de um módulo para o outro criaria acoplamento
//    Manutenção ↔ Operacional por causa de 8 linhas —, mas o próprio comentário
//    dizia: *"Se um terceiro módulo precisar, aí sim vira src/utils/"*. A
//    Auditoria foi o terceiro. Este arquivo é o cumprimento daquela instrução;
//    as duas cópias foram apagadas e todos passaram a importar daqui.
const useEhCompacto = (limite = 768) => {
  const [compacto, setCompacto] = useState(() => window.innerWidth <= limite);
  useEffect(() => {
    const onResize = () => setCompacto(window.innerWidth <= limite);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [limite]);
  return compacto;
};

export default useEhCompacto;
